import { LmsHttpHelper, NO_DATA_MESSAGE } from '../../utils/HttpHelper';

const getLmsUserAccountByPersonIdData = (personId, state, setState) => {
  if (state.isObjLoading !== true && !state.message) {
    const newState = {
      ...state,
      isObjLoading: true,
      isObjLoaded: false,
      personId,
      message: 'Loading...'
    };
    setState(newState);

    const personIdForUrl = personId ? encodeURIComponent(personId) : 0;
    const url = `/User/user/${personIdForUrl}`;
    LmsHttpHelper(url, 'GET')
      .then((objData) => {
        if (!objData) {
          throw new Error(NO_DATA_MESSAGE);
        } else {
          setState({
            ...newState,
            isObjLoading: false,
            isObjLoaded: true,
            objData,
            message: ''
          });
        }
      })
      .catch((e) => {
        const message = e && e.message ? e.message : NO_DATA_MESSAGE;
        setState({
          ...newState,
          isObjLoading: false,
          isObjLoaded: false,
          message: message
        });
      });
  }
};

export default getLmsUserAccountByPersonIdData;